export class MccImpactFilter {
  threshold: number;

  constructor(threshold) {
    this.threshold = threshold;
  }
}
